import { BotFeatures } from '@feedyou/schema'
import noteStepSchema from '@feedyou/schema/schema/steps/note.json'

import { useBaseSchema, removeConditionPropsFromSchema } from '../../../../../../features/schema'

export function useFormSchema(sdkFeatures: BotFeatures[] = []) {
  const schema = useBaseSchema(noteStepSchema)
  return removeConditionPropsFromSchema(schema, sdkFeatures)
}
